export enum ACTIONS {
  SAVE_TABLE_SETTINGS_TO_STORE = 'SAVE_TABLE_SETTINGS_TO_STORE',
  UPDATE_GAME_ID = 'UPDATE_GAME_ID',
  UPDATE_DEALER = 'UPDATE_DEALER',
}

export interface IBetsAbstract<TypeValue> {
  [index: string]: TypeValue;
}

export interface ILimit {
  min: number;
  max: number;
  payouts?: { type: string; value: number }[];
  rounds?: number;
}

export type TableLimitsType = IBetsAbstract<ILimit>;

export interface ITableSettingsState {
  tableId: string;
  tableName: string;
  gameId: string | null;
  displayingWinResult: number;
  dealer: {
    nickname: string;
  };
  tableLimits: TableLimitsType;
}
